import { blocksFormGenerator } from '@plone/volto/helpers/Blocks/Blocks';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  columns: {
    id: 'columns',
    defaultMessage: 'columns',
  },
});

const templates = (type) => (intl) => [
  {
    id: 'twoblocks',
    title: `2 ${intl.formatMessage(messages.columns)}`,
    blocksData: blocksFormGenerator(2, type),
  },
  {
    id: 'threeblocks',
    title: `3 ${intl.formatMessage(messages.columns)}`,
    blocksData: blocksFormGenerator(3, type),
  },
  {
    id: 'fourblocks',
    title: `4 ${intl.formatMessage(messages.columns)}`,
    blocksData: blocksFormGenerator(4, type),
  },
];

export default templates;
